import Model from '../BaseModel'
import i18n from '@/plugins/i18n'

export default class Product extends Model {
    resourceName() {
        return 'products'
    }

    fields() {
        return ['name', 'price', 'installments']
    }

    computed() {
        return {
            formattedPrice(product) {
                return i18n.n(product.price, 'currency')
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.product.attributes.name'),
                value: 'name',
            },
            {
                text: i18n.t('resources.product.attributes.price'),
                value: 'formattedPrice',
            },
            {
                text: i18n.t('resources.product.attributes.installments'),
                value: 'installments',
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
